const WHATSAPP_HOSTS = /^https?:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//i

/**
 * WhatsApp deep links leave the site (WhatsApp Web or the app handoff page),
 * so they open in a new tab instead of navigating the visitor away.
 */
export const anchorTargetProps = (href: string | undefined) =>
	href && WHATSAPP_HOSTS.test(href) ? ({ target: '_blank', rel: 'noopener noreferrer' } as const) : {}
